import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import type { MediaViewPdfComponent } from './media-view-pdf.component';

@Component({
  selector: 'fc-pdf-zoom-controls',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex items-center gap-4' },
  template: `
    <fc-button
      variant="icon"
      icon="icon-remove"
      color="white"
      ariaLabel="Zoom out"
      (click)="viewer().zoomOut()"
    />
    <span class="w-48 text-center text-sm text-white tabular-nums">
      @if (viewer().zoomPercent(); as zoomPercent) {
        {{ zoomPercent }}%
      }
    </span>
    <fc-button
      variant="icon"
      icon="icon-add"
      color="white"
      ariaLabel="Zoom in"
      (click)="viewer().zoomIn()"
    />
  `,
  imports: [ButtonComponent],
})
export class PdfZoomControlsComponent {
  readonly viewer = input.required<MediaViewPdfComponent>();
}
